// Authentication is held by the HttpOnly cookie. CSRF and session identity stay in memory.
let generation = 0;
let csrfToken = '';
let authenticated = false;
const requests = new Set();
export const sessionGeneration = () => generation;
export const sessionCsrf = () => csrfToken;
export const hasWebSession = () => authenticated;
export function trackRequest(controller) { requests.add(controller); return () => requests.delete(controller); }
export function changeSession(token = '', active = false) {
  generation += 1;
  for (const controller of requests) controller.abort();
  requests.clear();
  csrfToken = token; authenticated = active;
  window.dispatchEvent(new Event('assetflow:session-changed'));
  return generation;
}
export function announceSignOut() {
  changeSession();
  localStorage.setItem('assetflow-signout', String(Date.now()));
  window.dispatchEvent(new Event('assetflow:auth-cleared'));
}
